import React from "react";

const Download2LineIcon = () => (
	<g>
		<path d='M13 10H18L12 16L6 10H11V3H13V10ZM4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19Z' />
	</g>
);

export default Download2LineIcon;
